export default __webpack_public_path__ + "static/media/manawp.e835ce64.svg";